// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global L, lyyski, FWP, handorgel */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),
        current_position: 0,
        markersArray: [],
        loadingMoreProperties: false,
        mapTileUrl: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
        mapTileAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }

            wntrTheme.rluCalcPropertyInfoWindowWidth();
        },

        /**
         * Dropdown / submenu handler
         */
        __submenuHandler: () => {
            const dropdownToggle = wntrTheme.body.find('.menu-item-has-children');

            if(!dropdownToggle.length) {
                return false;
            }

            dropdownToggle.on('click', function(event) {
                if($(event.target).is('a')) {
                    return;
                }
                $(this).toggleClass('is-active');
                $(this).find('.toggle-sub-menu').toggleClass('is-active');
                $(this).find('.sub-menu').slideToggle(100);
            });
        },

        __propertyCardBadgeBiddingCountDown: function() {
            const cardCountdowns = wntrTheme.body.find('.property__badge--active-bidding');

            cardCountdowns.each(function() {
                const cardCountdown = $(this);
                const biddingEnds = new Date(cardCountdown.data('bidding-ends')).getTime();

                function updateCountdown() {
                    const now = new Date().getTime();
                    const timeLeft = biddingEnds - now;

                    if(timeLeft < 0) {
                        cardCountdown.text('Budgivningen är avslutad');
                        cardCountdown.removeClass('is-active').addClass('has-ended');
                        clearInterval(interval);
                        return;
                    }

                    cardCountdown.addClass('is-active').removeClass('has-ended');

                    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

                    let countdownText = '';
                    if(days > 0) {
                        countdownText += days + 'd ';
                    }
                    if(hours > 0 || days > 0) {
                        countdownText += hours + 'h ';
                    }
                    if(minutes > 0 || hours > 0 || days > 0) {
                        countdownText += minutes + 'm ';
                    }
                    countdownText += seconds + 's';

                    cardCountdown.find('#time-left').text(countdownText);
                }

                const interval = setInterval(updateCountdown, 1000);
                updateCountdown(); // Initial call to display the countdown immediately
            });
        },

        /**
         * Handle custom calendly section
         */
        __customCalendly: function() {
            wntrTheme.body.find('.custom__calendar-card').on('click', function(e) {
                e.preventDefault();
                wntrTheme.body.find('.custom__calendar-card').removeClass('active');
                wntrTheme.body.find('.custom__calendar').removeClass('active');

                $(this).addClass('active');
                wntrTheme.body.find('.custom__calendar[data-cal="' + $(this).data('cal') + '"]').addClass('active');
                wntrTheme.body.find('.custom__calendars')[0].scrollIntoView({ behavior: "smooth" });
            });
        },

        /**
         * Custom mobile gallery
         *
         * Images are loaded on demand once the gallery is opened: an IntersectionObserver rooted in the scrollable
         * gallery container loads images a couple of screens ahead of the viewport and failed requests are retried.
         */
        __customMobileGallery: function() {
            const $gallery = wntrTheme.body.find('.property-gallery-mobile');

            if(!$gallery.length) {
                return;
            }

            const $images = $gallery.find('img[data-src]');
            const maxAttempts = 3;
            let loadingStarted = false;

            wntrTheme.body.find('.property-gallery-trigger').on('click', function(e) {
                if($(window).width() < 960) {
                    e.preventDefault();
                    wntrTheme.current_position = wntrTheme.document.scrollTop();
                    wntrTheme.body.find('.property-gallery-mobile__header').addClass('active');
                    $gallery.addClass('active');
                    wntrTheme.body.addClass('body--fixed-mobile');
                    startLoadingImages();
                    return false;
                }
            });

            wntrTheme.body.find('.property-gallery-mobile__header button').on('click', function() {
                wntrTheme.body.find('.property-gallery-mobile__header').removeClass('active');
                $gallery.removeClass('active');
                wntrTheme.body.removeClass('body--fixed-mobile');
                wntrTheme.document.scrollTop(wntrTheme.current_position);
            });

            function startLoadingImages() {
                if(loadingStarted) {
                    return;
                }

                loadingStarted = true;

                if(!('IntersectionObserver' in window)) {
                    $images.each(function() {
                        loadImage(this, 1);
                    });

                    return;
                }

                const observer = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        if(entry.isIntersecting) {
                            observer.unobserve(entry.target);
                            loadImage(entry.target, 1);
                        }
                    });
                }, {
                    root: $gallery[0],
                    rootMargin: '200% 0px'
                });

                $images.each(function() {
                    observer.observe(this);
                });
            }

            function loadImage(img, attempt) {
                img.onload = function() {
                    img.classList.add('is-loaded');
                };

                img.onerror = function() {
                    if(attempt >= maxAttempts) {
                        img.classList.add('has-failed');
                        return;
                    }

                    img.removeAttribute('srcset');
                    img.removeAttribute('src');

                    setTimeout(function() {
                        loadImage(img, attempt + 1);
                    }, 1500 * attempt);
                };

                if(img.getAttribute('data-srcset')) {
                    img.setAttribute('srcset', img.getAttribute('data-srcset'));
                }

                img.setAttribute('src', img.getAttribute('data-src'));
            }
        },

        /**
         * Set Cookie
         */
        setCookie: function(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            const expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },

        /**
         * Get Cookie
         */
        getCookie: function(cname) {
            const name = cname + "=";
            const decodedCookie = decodeURIComponent(document.cookie);
            const ca = decodedCookie.split(';');
            for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while(c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if(c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },

        /**
         * Start popup timer
         */
        startPopupTimer: function(seconds) {

            const interval = setInterval(function() {

                wntrTheme.setCookie('popup_timeout', seconds, 2);

                if(--seconds < 0) {
                    wntrTheme.body.find('.popup').trigger('click');

                    wntrTheme.body.find('.popup').find('.fancybox-button').on('click', function() {
                        wntrTheme.setCookie('user_has_closed_popup', 'true', 2);
                    });

                    wntrTheme.body.find('.popup__link').on('click', function() {
                        wntrTheme.setCookie('user_has_closed_popup', 'true', 2);
                        window.location.href = $(this).attr('href');
                    });

                    clearInterval(interval);
                }
            }, 1000);
        },

        /**
         * Calculate screen width
         */
        rluCalcPropertyInfoWindowWidth: function() {
            const information = wntrTheme.body.find('.screen-section .information');

            if(information) {
                const max = Math.max(...information.map(function(i, o) {
                    return jQuery(o).width();
                }));

                information.width(max);
            }
        },

        /**
         * Hotfix raspberry pi screens
         */
        __reloadScreenPageEveryFourthHour: function() {
            if(wntrTheme.body.hasClass('single-screen')) {
                setInterval(function() {
                    const randomHash = Math.random().toString(36).substring(7);
                    const newUrl = window.location.href.split('?')[0] + '?' + randomHash;
                    window.location.href = newUrl + '&cacheBust=' + new Date().getTime();
                }, 1000 * 60 * 10); //  Once every 10 minute
            }
        },

        /**
         * Toggle search page tabs
         */
        __toggleSearchPageTabs: function() {
            const $search_tab = wntrTheme.body.find('.search__results-tab');

            $search_tab.on('click', function() {
                wntrTheme.body.find('.search__results-tab').removeClass('is-active');
                wntrTheme.body.find('.search__result').removeClass('is-active');

                $(this).addClass('is-active');
                wntrTheme.body.find('.search__result--' + $(this).data('tab')).addClass('is-active');
            });
        },

        /**
         * fancybox popup handler
         */
        __fancyboxPopupHandler: function() {

            if(wntrTheme.body.hasClass('lyyski__popup')) {

                window.onload = function() {
                    let seconds = null;

                    if(wntrTheme.getCookie('popup_timeout').length) {
                        seconds = wntrTheme.getCookie('popup_timeout');
                    } else {
                        seconds = parseInt(wntrTheme.body.find('.popup').data('timeout'));
                    }

                    if(!wntrTheme.getCookie('user_has_closed_popup') || parseInt(wntrTheme.getCookie('popup_timeout')) > 0) {
                        wntrTheme.startPopupTimer(seconds);
                    }
                };
            }
        },

        /**
         * Load more properties with infinite scroll
         */
        __loadMorePropertiesOnScroll: function() {
            if(wntrTheme.body.find('.archive-property-preview__properties, .page-section-lyyski_home').length) {
                const $load_more_properties_trigger = wntrTheme.body.find('.archive-property-preview__show-more-objects');

                $(document).on('facetwp-loaded', function() {
                    wntrTheme.loadingMoreProperties = false;
                });

                let map_scroll_timeout = null;
                const map_scroll_throttle = 50;
                $(window).on('scroll', function() {
                    if(!map_scroll_timeout) {
                        map_scroll_timeout = setTimeout(function() {
                            const $load_more_button = wntrTheme.body.find('.archive-property-preview__show-more-objects.map--hidden .facetwp-load-more:not(.facetwp-hidden)');
                            if(isScrolledIntoView($load_more_properties_trigger) && $load_more_button.length && !wntrTheme.loadingMoreProperties) {
                                $load_more_button.trigger('click');
                                wntrTheme.loadingMoreProperties = true;
                            }

                            map_scroll_timeout = null;
                        }, map_scroll_throttle);
                    }
                });
            }

            function isScrolledIntoView(elem) {
                const docViewTop = $(window).scrollTop();
                const docViewBottom = docViewTop + $(window).height();

                const elemTop = $(elem).offset().top;
                const elemBottom = elemTop + $(elem).height();

                return ((elemBottom >= docViewTop) && (elemTop <= docViewBottom));
            }
        },

        /**
         * Scroll to broker section for single property
         */
        __scrollToBrokerSectionSingleProperty: function() {
            const $scrollToBrokersBtn = wntrTheme.body.find('.property-information__broker-link a');

            if($scrollToBrokersBtn.length) {
                $scrollToBrokersBtn.on('click', function(e) {
                    e.preventDefault();

                    $('html, body').animate({
                        scrollTop: ($('#property-section-brokers').offset().top - ($(window).width() >= 720 ? 70 : 50))
                    }, 500);
                });
            }
        },

        /**
         * Handle single property facts
         */
        __handleSinglePropertyFacts: function() {
            const $facts = wntrTheme.body.find('.property-fact');

            if($facts.length) {
                $.each($facts, function() {
                    new handorgel($(this)[0]);
                });
            }
        },

        /**
         * Handle single property map
         */
        __handleScreenUpdateOnObjectUpdate: () => {
            if(wntrTheme.body.hasClass('single-screen')) {

                const postData = [];
                const action = 'handle_object_update';
                const screenId = wntrTheme.body.find('.screen-section').data('screen-id');

                setInterval(() => {

                    $.each(wntrTheme.body.find('.screen-property'), function() {
                        const id = $(this).data('id');
                        const update = $(this).data('update');
                        postData.push({ screenId, id, update });
                    });

                    const data = {
                        'action': action,
                        'data': postData
                    };

                    $.ajax({
                        url: lyyski.ajax_url,
                        data: data,
                        type: 'POST',
                        dataType: 'json',
                        success: function(response) {
                            if(response && response['type'] === 'rand') {
                                wntrTheme.body.find('.screen-property-wrapper').html(response['html']);
                                postData.length = 0;
                            } else {
                                wntrTheme.body.find(`#${response['id']}.screen-property`).first().replaceWith(response['html']);
                                postData.length = 0;
                            }

                            wntrTheme.rluCalcPropertyInfoWindowWidth();
                        },
                        fail: function() {
                            postData.length = 0;
                        }
                    });
                }, 60000);
            }
        },

        /**
         * Create a Leaflet map with OpenStreetMap tiles and the theme's fullscreen control
         */
        createMap: function(element, options) {
            const map = L.map(element, Object.assign({
                zoomControl: false,
                attributionControl: false
            }, options));

            L.tileLayer(wntrTheme.mapTileUrl, {
                maxZoom: 19,
                attribution: wntrTheme.mapTileAttribution
            }).addTo(map);

            L.control.zoom({ position: 'bottomright' }).addTo(map);
            L.control.attribution({ position: 'bottomleft' }).addTo(map);
            wntrTheme.addFullscreenControl(map);

            return map;
        },

        /**
         * Add a control that toggles a map between inline and fullscreen display
         */
        addFullscreenControl: function(map) {
            const fullscreenClass = 'leaflet-container--fullscreen';
            let scrollPosition = 0;

            function toggleFullscreen(force) {
                const container = map.getContainer();
                const isFullscreen = typeof force === 'boolean' ? force : !container.classList.contains(fullscreenClass);

                // Locking the body scroll resets the scroll position, so it is restored when leaving fullscreen
                if(isFullscreen) {
                    scrollPosition = wntrTheme.document.scrollTop();
                }

                container.classList.toggle(fullscreenClass, isFullscreen);
                wntrTheme.body.toggleClass('map-fullscreen-is-active', isFullscreen);
                map.invalidateSize();

                if(!isFullscreen) {
                    wntrTheme.document.scrollTop(scrollPosition);
                }
            }

            const FullscreenControl = L.Control.extend({
                options: {
                    position: 'topright'
                },
                onAdd: function() {
                    const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-fullscreen');
                    const button = L.DomUtil.create('a', 'leaflet-control-fullscreen__button', container);

                    button.href = '#';
                    button.title = 'Fullskärm';
                    button.setAttribute('role', 'button');
                    button.setAttribute('aria-label', 'Fullskärm');

                    L.DomEvent.on(button, 'click', function(e) {
                        L.DomEvent.stop(e);
                        toggleFullscreen();
                    });

                    // The control is an anchor with role="button", so Space has to activate it like a native button
                    L.DomEvent.on(button, 'keydown', function(e) {
                        if(e.key === ' ' || e.key === 'Spacebar') {
                            L.DomEvent.stop(e);
                            toggleFullscreen();
                        }
                    });

                    return container;
                }
            });

            wntrTheme.document.on('keyup', function(e) {
                if(e.key === 'Escape' && map.getContainer().classList.contains(fullscreenClass)) {
                    toggleFullscreen(false);
                }
            });

            map.addControl(new FullscreenControl());
        },

        /**
         * Handle single property map
         */
        __handleSinglePropertyMap: function() {
            const $map_element = wntrTheme.body.find('.property-map');

            if(!$map_element.length || typeof L === 'undefined') {
                return;
            }

            wntrTheme.body.find('.property-map__preview-trigger').on('click', function() {
                initSinglePropertyMap();
                wntrTheme.body.find('.property-map__preview, .property-map__preview-trigger').remove();
            });

            function initSinglePropertyMap() {
                if($map_element.hasClass('property-map--initialized')) {
                    return;
                }

                $map_element.addClass('property-map--initialized');

                const lat = parseFloat($map_element.data('lat'));
                const lng = parseFloat($map_element.data('lng'));
                const zoom = parseInt($(window).width() >= 720 ? $map_element.data('zoom-desktop') : $map_element.data('zoom-mobile'), 10);
                const title = $map_element.data('title');
                const address = $map_element.data('address');

                const map = wntrTheme.createMap($map_element[0], {
                    center: [lat, lng],
                    zoom: isNaN(zoom) ? 13 : zoom
                });

                // Plain scrolling keeps scrolling the page. Trackpad pinch (reported as wheel + ctrlKey) and
                // ctrl/cmd + wheel zoom the map. Stopped on the parent in the capture phase so Leaflet never sees it.
                $map_element.parent()[0].addEventListener('wheel', function(e) {
                    if(!e.ctrlKey && !e.metaKey) {
                        e.stopPropagation();
                    }
                }, true);

                const marker = L.marker([lat, lng], {
                    title: title,
                    icon: L.icon({
                        iconUrl: lyyski.get_template_directory_uri + '/src/images/pin.svg',
                        iconSize: [20, 20],
                        iconAnchor: [10, 10],
                        popupAnchor: [0, -10]
                    })
                }).addTo(map);

                marker.bindPopup('<div class="property-map__info-window"><h2>' + title + '</h2><p>' + address + '</p></div>');
            }
        },

        /**
         * Toggle single property descriptions
         */
        __toggleSinglePropertyDescriptions: function() {
            const $toggleBtn = wntrTheme.body.find('.property-information__content-text-toggle');

            $toggleBtn.on('click', function() {
                const $btn = $(this);

                $btn.toggleClass('is-active');
                $btn.closest('.property-information__content-inner').find('.property-information__content-text').toggleClass('is-active');

                if($btn.hasClass('is-active')) {
                    $btn.find('span').text($btn.data('read-less-text'));
                } else {
                    $btn.find('span').text($btn.data('read-more-text'));
                }
            });
        },

        /**
         * Toggle header menu
         */
        __toogleHeaderMenu: function() {
            const toggleHeaderButton = wntrTheme.body.find('.header__toggle-menu');
            const toggleHeaderElements = wntrTheme.body.find('.header__toggle-menu, .header__navigation-overlay, .header__navigation-close, .header__toggle-search');

            toggleHeaderElements.on('click', function() {
                if(wntrTheme.body.hasClass('header--mobile-menu-active')) {
                    wntrTheme.body.removeClass('body--fixed');
                    wntrTheme.body.removeClass('header--mobile-menu-active');
                    toggleHeaderButton.removeClass('is-active');
                    if(wntrTheme.current_position <= 30 && !wntrTheme.body.find('header').hasClass('header--mobile-buttons')) {
                        wntrTheme.body.find('.header').removeClass('header--solid');
                    }

                    if($(window).width() <= 705) {
                        wntrTheme.document.scrollTop(wntrTheme.current_position);
                    }
                } else {
                    wntrTheme.body.addClass('header--mobile-menu-active');
                    toggleHeaderButton.addClass('is-active');

                    // Focus search if search button is clicked
                    if($(this).hasClass('header__toggle-search')) {
                        wntrTheme.body.find('.header__navigation-search input[type="search"]').focus();
                    }

                    // Save current position from top
                    wntrTheme.current_position = wntrTheme.document.scrollTop();

                    // SetTimeout till the css animation has ended
                    setTimeout(function() {
                        wntrTheme.body.addClass('body--fixed');
                    }, 200);
                }
            });

            $(document).keyup(function(e) {
                if(e.keyCode === 27 && wntrTheme.body.hasClass('header--mobile-menu-active')) {
                    wntrTheme.body.removeClass('header--mobile-menu-active');
                    wntrTheme.body.removeClass('body--fixed');
                    toggleHeaderButton.removeClass('is-active');
                }
            });
        },

        /**
         * Toogle read more text content
         */
        __toggleReadMoreTextContent: () => {
            wntrTheme.body.find('.text-block__content-read-more').on('click', function() {
                $(this).closest('.text-block__content--expandable').addClass('expanded');
            });
        },

        /**
         * Toggle header background color on scroll
         */
        __toggleHeaderBackground: () => {
            let scrollTimeout = null;
            const throttle = 50;

            if(wntrTheme.body.find('header').hasClass('header--mobile-buttons')) return;

            toggleHeaderBackgroundClass();

            // Simple scroll throttle
            $(window).on('scroll', function() {
                if(!scrollTimeout) {
                    scrollTimeout = setTimeout(function() {
                        toggleHeaderBackgroundClass();
                        scrollTimeout = null;
                    }, throttle);
                }
            });

            function toggleHeaderBackgroundClass() {
                const scroll_length = 30;
                const scroll = $(window).scrollTop();

                if(scroll >= scroll_length) {
                    wntrTheme.body.find('header').addClass('header--solid');
                } else {
                    wntrTheme.body.find('header').removeClass('header--solid');
                }
            }
        },

        /**
         * Add class to body if iOS
         */
        __addBodyClassIfIOS: function() {
            if(iOS()) {
                wntrTheme.body.addClass('device--ios');
            }

            function iOS() {
                return [
                    'iPad Simulator',
                    'iPhone Simulator',
                    'iPod Simulator',
                    'iPad',
                    'iPhone',
                    'iPod'
                ].includes(navigator.platform)
                    // iPad on iOS 13 detection
                    || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
            }
        },


        /**
         * Init accordions
         */
        __initAccordions: () => {
            if(wntrTheme.body.find('.handorgel').length) {
                $.each(wntrTheme.body.find('.handorgel'), function() {
                    new handorgel($(this)[0]);
                });
            }
        },

        /**
         * Handle toggle events
         */
        __toggleHandler: () => {
            const readMore = wntrTheme.body.find('.handorgel__content__inner__read-more');

            if(readMore.length) {
                readMore.on('click', function() {
                    $(this).toggleClass('handorgel__content__inner__read-more--active');
                    $(this).parent('.handorgel__content__inner').toggleClass('handorgel__content__inner--expandable');
                    $(this).parent('.handorgel__content__inner').toggleClass('handorgel__content__inner--expanded');
                    $(this).closest('.handorgel__content').css('height', 'auto');
                });
            }
        },

        /**
         * Toggle functionality for additional filters
         */
        __filterToggle: () => {
            const toggleBtn = wntrTheme.body.find('.archive-property-preview__toggle');
            if(toggleBtn.length) {
                toggleBtn.on('click', () => {
                    toggleBtn.toggleClass('is-active');
                    wntrTheme.body.find('.facetwp-additional-filters').toggleClass('is-active');
                });
            }
        },

        /**
         * On facet loaded/refresh event
         */
        __onFacetLoaded: () => {
            if(wntrTheme.body.hasClass('post-type-archive-property')) {
                const cards = wntrTheme.body.find('.archive-property-preview__properties');
                $(document).on('facetwp-loaded', function() {
                    wntrTheme.body.find('.property--card').children('.property__top-wrapper').matchHeight();
                    wntrTheme.body.find('.property__bottom-wrapper').matchHeight();
                    wntrTheme.body.find('.property__address').matchHeight();

                    // Re-initialize slick slider for archive slider after FacetWP load
                    const archiveSlider = wntrTheme.body.find('.archive-property-preview__properties--slider');
                    if(archiveSlider.length && !archiveSlider.hasClass('slick-initialized')) {
                        const settings = {
                            dots: false,
                            infinite: false,
                            speed: 300,
                            swipeToSlide: true,
                            slidesToShow: 4,
                            prevArrow: '<button class="slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true" style=""><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M7 1L2 6L7 11" stroke="#241F1F" stroke-width="2" stroke-linecap="round"/></g></svg></button>',
                            nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11L6 6L1 1" stroke="#241F1F" stroke-width="2" stroke-linecap="round"/></svg></button>',
                            responsive: [
                                {
                                    breakpoint: 1448,
                                    settings: {
                                        slidesToShow: 4,
                                        arrows: true
                                    }
                                },
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 3,
                                        arrows: false,
                                    }
                                },
                                {
                                    breakpoint: 720,
                                    settings: {
                                        slidesToShow: 2,
                                        arrows: false,
                                    }
                                },
                                {
                                    breakpoint: 420,
                                    settings: {
                                        slidesToShow: 1.5,
                                        arrows: false,
                                    }
                                },
                            ]
                        };
                        archiveSlider.slick(settings);
                    }

                    cards.removeClass('is-loading');
                });
                $(document).on('facetwp-refresh', function() {
                    cards.addClass('is-loading');
                });
            }
        },

        /**
         * Property archive map with markers for the FacetWP-filtered properties
         */
        __handleCustomFacetwpMapPins: () => {
            const showMapBtn = wntrTheme.body.find('.archive-property-preview__toggle-map');
            const showMoreObjects = wntrTheme.body.find('.archive-property-preview__show-more-objects');
            const mapWrapper = wntrTheme.body.find('.archive-property-preview__map');
            const filterBtn = wntrTheme.body.find('.archive-property-preview__toggle-filter');
            const mapContainer = document.getElementById('facetwp-map');
            const labelZoomLevel = 14;
            let map = null;

            filterBtn.on('click', () => {
                wntrTheme.body.toggleClass('filter-map-is-active');

                if(wntrTheme.body.hasClass('filter-map-is-active')) {
                    $('html, body').animate({ scrollTop: 0 }, 50);
                }
            });

            if(!showMapBtn.length || !mapContainer || typeof L === 'undefined') {
                return;
            }

            const bulletIcon = L.icon({
                iconUrl: lyyski.get_template_directory_uri + '/src/images/bullet.svg',
                iconSize: [17, 17],
                iconAnchor: [8.5, 8.5],
                tooltipAnchor: [0, -8]
            });

            const yellowBulletIcon = L.icon({
                iconUrl: lyyski.get_template_directory_uri + '/src/images/bullet-yellow.svg',
                iconSize: [17, 17],
                iconAnchor: [8.5, 8.5],
                tooltipAnchor: [0, -8]
            });

            showMapBtn.on('click', () => {
                showMapBtn.toggleClass('map-btn-is-active');
                wntrTheme.body.toggleClass('property-map-is-active');
                showMoreObjects.toggleClass('map--hidden');

                const mapIsActive = showMapBtn.hasClass('map-btn-is-active');

                if(!mapIsActive) {
                    wntrTheme.body.removeClass('filter-map-is-active');
                    FWP.refresh();
                }

                toggleMap();

                // The container is hidden until the first toggle, so the map can only be created or measured once it is visible
                if(map === null) {
                    setupMap();
                } else {
                    map.invalidateSize();
                }

                // FWP.settings already holds the matching IDs from the page load or the latest filtering,
                // so the markers can be drawn right away instead of waiting for a FacetWP round trip
                if(mapIsActive) {
                    clearCurrentMarkers();
                    renderMarkers();
                }
            });

            $(document).on('facetwp-refresh', () => {
                if(map !== null) {
                    mapWrapper.addClass('is-loading');
                    clearActiveMarker();
                }
            });

            $(document).on('facetwp-loaded', () => {
                if(map !== null) {
                    clearCurrentMarkers();
                    renderMarkers();
                    mapWrapper.removeClass('is-loading');
                }
            });

            function toggleMap() {
                wntrTheme.body.find('.archive-property-preview__properties').toggleClass('map-active');
                wntrTheme.body.find('.archive-property-preview__show-more-objects').toggleClass('map-active');
                wntrTheme.body.find('.facetwp-facet-sortering').toggleClass('map-active');
                mapWrapper.toggleClass('map-active');

                $('html, body').animate({
                    scrollTop: $("#facetwp-map").offset().top - ($(window).width() >= 720 ? 70 : 50)
                }, 500);
            }

            function setupMap() {
                map = wntrTheme.createMap(mapContainer, {
                    center: [60.198116, 19.994465],
                    zoom: 9
                });

                map.on('zoomend', updateLabelVisibility);
                updateLabelVisibility();
            }

            /**
             * Show price labels instead of bullets once the map is zoomed in far enough
             */
            function updateLabelVisibility() {
                mapContainer.classList.toggle('property-map--show-labels', map.getZoom() >= labelZoomLevel);
            }

            function clearCurrentMarkers() {
                wntrTheme.markersArray.forEach((marker) => {
                    marker.remove();
                });

                wntrTheme.markersArray = [];
            }

            /**
             * All properties are rendered in a hidden list; when FacetWP filters are active only the IDs it reports
             * as matching (FWP.settings.filtered_post_ids, all pages) get a marker.
             */
            function renderMarkers() {
                const filteredIds = typeof FWP !== 'undefined' && FWP.settings && Array.isArray(FWP.settings.filtered_post_ids)
                    ? FWP.settings.filtered_post_ids.map(String)
                    : null;

                mapWrapper.find('.property--map').each(function() {
                    const id = $(this).data('id');

                    if(filteredIds !== null && filteredIds.indexOf(String(id)) === -1) {
                        return;
                    }

                    const lat = parseFloat($(this).data('latitude'));
                    const lng = parseFloat($(this).data('longitude'));

                    if(isNaN(lat) || isNaN(lng)) {
                        return;
                    }

                    const price = $(this).data('price');

                    const marker = L.marker([lat, lng], {
                        icon: bulletIcon,
                        propertyId: id
                    });

                    marker.bindTooltip('<button data-id="' + id + '" class="info-window" type="button">' + price + '</button>', {
                        permanent: true,
                        interactive: true,
                        direction: 'top',
                        opacity: 1,
                        className: 'property-map__label'
                    });

                    // Clicks on the interactive tooltip propagate to the marker, so one handler covers both
                    marker.on('click', () => {
                        activateMarker(marker);
                    });

                    marker.addTo(map);
                    wntrTheme.markersArray.push(marker);
                });
            }

            function activateMarker(marker) {
                clearActiveMarker();

                marker.setIcon(yellowBulletIcon);
                setTooltipActive(marker, true);
                mapWrapper.find('.property--map[data-id="' + marker.options.propertyId + '"]').addClass('property--is-active');
            }

            function clearActiveMarker() {
                wntrTheme.markersArray.forEach((marker) => {
                    marker.setIcon(bulletIcon);
                    setTooltipActive(marker, false);
                });

                mapWrapper.find('.property--is-active').removeClass('property--is-active');
            }

            function setTooltipActive(marker, isActive) {
                const tooltip = marker.getTooltip();
                const element = tooltip ? tooltip.getElement() : null;

                if(element) {
                    element.classList.toggle('is-active', isActive);
                }
            }

            wntrTheme.body.find('.property__close').on('click', (e) => {
                e.preventDefault();
                clearActiveMarker();
            });

            wntrTheme.body.find('.archive-property-preview__close-map').on('click', () => {
                FWP.soft_refresh = true;
                FWP.refresh();
                toggleMap();
                showMapBtn.toggleClass('map-btn-is-active');
                clearActiveMarker();
            });
        },

        /**
         * Matchheight init
         */
        __doMatchHeight: () => {
            if(wntrTheme.body.find('.property-preview--card').length) {
                wntrTheme.body.find('.property__top-wrapper').matchHeight();
            }

            if(wntrTheme.body.find('.property__bottom-wrapper').length) {
                wntrTheme.body.find('.property__bottom-wrapper').matchHeight();
            }

            if(wntrTheme.body.find('.property__address').length) {
                wntrTheme.body.find('.property__address').matchHeight();
            }

            if(wntrTheme.body.find('.broker').length) {
                wntrTheme.body.find('.broker').matchHeight();
            }

        },

        /**
         * Slick slider
         */
        __initSlickSlider: function() {

            const layout = wntrTheme.body.find('.property-preview--slider');
            const archiveSlider = wntrTheme.body.find('.archive-property-preview__properties--slider');

            const settings = {
                dots: false,
                infinite: false,
                speed: 300,
                swipeToSlide: true,
                slidesToShow: 4,
                prevArrow: '<button class="slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true" style=""><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M7 1L2 6L7 11" stroke="#241F1F" stroke-width="2" stroke-linecap="round"/></g></svg></button>',
                nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="" aria-disabled="false"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 11L6 6L1 1" stroke="#241F1F" stroke-width="2" stroke-linecap="round"/></svg></button>',
                responsive: [
                    {
                        breakpoint: 1448,
                        settings: {
                            slidesToShow: 4,
                            arrows: true
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 720,
                        settings: {
                            slidesToShow: 2,
                            arrows: false,
                        }
                    },
                    {
                        breakpoint: 420,
                        settings: {
                            slidesToShow: 1.5,
                            arrows: false,
                        }
                    },
                ]
            };

            if(layout.length) {
                layout.find('.property-preview__properties').slick(settings);
            }

            if(archiveSlider.length) {
                archiveSlider.slick(settings);
            }
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);